import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
} from "../../../helpers/utils/RtkQueryUtils";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
import {downloadFile} from "../../../helpers/utils/FileUtils";

export const orderEventApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchOrderEventApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/search-order-events?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['orderEvent'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getOrderEventApiById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-association-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['orderEventById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportOrderEventData: build.query({
            query: (query) => {
                return {
                    url: `/export/association?`,
                    method: 'GET',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("appraisal rolls"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
    }),
});


export const {
    useGetOrderEventApiByIdQuery,
    useSearchOrderEventApiQuery,
    useLazyExportOrderEventDataQuery,
} = orderEventApi;